// extracted by mini-css-extract-plugin
export default {"clickableText":"style_clickableText__nG+U-"};